import React, { useState } from "react";
//import { WEDDING } from "../utils/config";

// ── GIFT CARDS ────────────────────────────────────────────
// Front shows title + icon · Click to flip · Back shows details.
// [EDIT] Change placeholder numbers below in the `back` arrays.
const GIFTS = [
  {
    ico: "🎁",
    title: "Wrapped and physical Gift",
    text: "If you wish to honor us with a physical gift, a dedicated gift table will be available on the day for wrapped presents.",
    front: "Tap for details",
    back: [
      ["Physical gifts are warmly welcomed"],
      ["Gift-boxed surprises are welcome too!"],
    ],
  },
  {
    ico: "💳",
    title: "Cash Gift",
    text: "Your generosity towards our new journey together means the world.",
    front: "Tap for details",
    back: [
      ["Orange Money", "74 874 272"],
      ["Pay2cell", "74 256 182"],
      ["Name", "Olorato Ebineng"],
      ["Stanbic Account No.", "9060002962360 Fairgrounds"],
      ["Please whatsapp your POP", "74 256 182"],
    ],
  },

  {
    ico: "⌚",
    title: "Gift Voucher",
    text: "A voucher from any of these stores helps us build our new home together.",
    front: "Tap for stores",
    back: [
      ["Builders Warehouse"],
      ["Game"],
      ["Woolworths"],
      ["HomeCorp"],
      ["Mr Price Home"],
    ],
  },
];

function GiftCard({ gift }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      onClick={() => setFlipped((f) => !f)}
      style={{ perspective: "1200px", minHeight: "300px", cursor: "pointer" }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          minHeight: "300px",
          transformStyle: "preserve-3d",
          WebkitTransformStyle: "preserve-3d",
          transition: "transform .7s cubic-bezier(.22,1,.36,1)",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* ── FRONT ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            background: "#fff",
            border: ".5px solid var(--sage-p)",
            borderRadius: "10px",
            padding: "34px 26px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 12px rgba(36,60,40,.06)",
          }}
        >
          <div
            style={{
              width: "54px",
              height: "54px",
              borderRadius: "50%",
              background: "var(--mint-p)",
              margin: "0 auto 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "21px",
              boxShadow: "0 4px 14px rgba(107,155,111,.14)",
            }}
          >
            {gift.ico}
          </div>
          <div
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "21px",
              marginBottom: "9px",
              color: "var(--deep)",
            }}
          >
            {gift.title}
          </div>
          <p
            style={{
              fontSize: "12px",
              color: "var(--muted)",
              lineHeight: 1.85,
              marginBottom: "20px",
            }}
          >
            {gift.text}
          </p>
          <div
            style={{
              display: "inline-block",
              padding: "8px 20px",
              border: ".5px solid var(--sage)",
              borderRadius: "18px",
              fontSize: "9px",
              letterSpacing: ".15em",
              textTransform: "uppercase",
              color: "var(--sage-d)",
            }}
          >
            {gift.front} ↻
          </div>
        </div>

        {/* ── BACK ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            background: "linear-gradient(158deg,var(--forest),var(--deep))",
            border: ".5px solid rgba(107,155,111,.3)",
            borderRadius: "10px",
            padding: "30px 26px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            boxShadow: "0 2px 12px rgba(36,60,40,.1)",
          }}
        >
          <div
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "18px",
              color: "#fff",
              textAlign: "center",
              marginBottom: "18px",
            }}
          >
            {gift.ico} {gift.title}
          </div>

          {gift.back.map(([label, value], i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "12px",
                padding: "8px 0",
                borderBottom:
                  i < gift.back.length - 1
                    ? ".5px solid rgba(107,155,111,.2)"
                    : "none",
              }}
            >
              <span
                style={{
                  fontSize: "9px",
                  letterSpacing: ".12em",
                  textTransform: "uppercase",
                  color: "var(--sage-l)",
                  flexShrink: 0,
                }}
              >
                {label}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  color: "#fff",
                  textAlign: "right",
                  fontWeight: 400,
                }}
              >
                {value}
              </span>
            </div>
          ))}

          <div
            style={{
              textAlign: "center",
              marginTop: "16px",
              fontSize: "8px",
              letterSpacing: ".14em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,.4)",
            }}
          >
            Tap to flip back ↻
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Gifts() {
  return (
    <section
      id="gifts"
      style={{ background: "var(--warm)", padding: "96px 36px" }}
    >
      <div style={{ maxWidth: "960px", margin: "0 auto" }}>
        <div
          className="reveal"
          style={{ marginBottom: "44px", textAlign: "center" }}
        >
          <div
            className="section-tag"
            style={{ justifyContent: "center", display: "flex" }}
          >
            Gift Registry
          </div>
          <h2 className="section-title">
            Celebrate <em>with us</em>
          </h2>
          <p
            style={{
              fontSize: "13.5px",
              lineHeight: 1.9,
              color: "var(--muted)",
              marginTop: "12px",
              maxWidth: "500px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Your presence is our greatest gift. If you wish to honour us
            further, tap any card below for details.
          </p>
        </div>

        <div
          className="reveal"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
            gap: "18px",
          }}
        >
          {GIFTS.map((gift, i) => (
            <GiftCard key={i} gift={gift} />
          ))}
        </div>
      </div>
    </section>
  );
}
